module.exports = __webpack_public_path__ + "img/success.a0606fe8.svg";